import { ActionTypes } from '../Actions/Actions';
import * as fromActions from '../Actions/Actions';
import DateUtils from '../../Utils/DateUtils';

export interface IStateCurrency {
    heart: number;
    coin: number;
    ts: number | null;
}

export const defaultCurrency: IStateCurrency = {
    heart: 5,
    coin: 0,
    ts: null,
};
export const StateCurrency = (
    state = defaultCurrency,
    action: fromActions.Actions
): IStateCurrency => {
    switch (action.type) {
        case ActionTypes.UPDATE_HEARTS:
            let reset = false;
            let timer = state.ts;
            const total = Math.max(0, state.heart + action.payload);
            if (state.ts !== null) {
                if (
                    DateUtils.timeRemainingTo(state.ts + DateUtils.minutesToMilliseconds(30)) <= 0
                ) {
                    reset = true;
                }
            } else {
                if (total < 5) {
                    reset = true;
                }
            }

            if (total < 5) {
                if (reset) {
                    timer = Date.now();
                }
            } else {
                timer = null;
            }

            return {
                ...state,
                heart: total,
                ts: timer,
            };
        case ActionTypes.UPDATE_COINS:
            return {
                ...state,
                coin: state.coin + action.payload,
            };
        default:
            return state;
    }
};

export const purchase = (state: IStateCurrency, amt: number) => {
    return state.coin >= amt;
};

export const LIFE_TIME = 30 * (60 * 1000);

// move to currency selector
export const initHearts = (n: number, lastStamp: number) => {
    if (n === 5) {
        return [n, null];
    }

    let ts = lastStamp;
    const lifeTime = 30 * (60 * 1000);
    const now = Date.now();
    const passed = now - lastStamp;
    let heartsAdded = 0;
    if (passed > lifeTime) {
        heartsAdded = Math.min(5 - n, Math.floor(passed / lifeTime));
        if (n + heartsAdded >= 5) {
            ts = null;
        } else {
            ts = now - heartsAdded * lifeTime;
        }
    }
    return [n + heartsAdded, ts];
};
